import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full max-w-lg rounded-lg bg-white p-6 shadow ring-1 ring-black ring-opacity-5" }
const _hoisted_2 = { class: "flex h-10 w-10 items-center justify-center rounded-md bg-brand-50" }
const _hoisted_3 = {
  key: 0,
  role: "alert",
  class: "mt-3 text-sm text-red-600"
}
const _hoisted_4 = { class: "mt-5 flex flex-wrap gap-3" }
const _hoisted_5 = {
  key: 0,
  role: "alert",
  class: "mt-3 text-sm text-red-600"
}

import { Squares2X2Icon } from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

import NeueButton from '@/components/neue/NeueButton.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import TheModal from '@/components/TheModal.vue'
import { merchantName } from '@/helpers/franchiseMerchant'
import api from '@/store/api'


export default {
  __name: 'FranchiseMenuSetupCard',
  setup(__props) {

const store = useStore()

const pickerOpen = ref(false)
const fromMerchantId = ref(null)
const creating = ref(false)
const error = ref('')

const options = computed(() =>
  (store.state.franchiseMerchants ?? []).map(merchant => ({ value: merchant.id, name: merchantName(merchant) }))
)

const openPicker = () => {
  error.value = ''
  fromMerchantId.value = null
  pickerOpen.value = true
}

const closePicker = () => {
  if (!creating.value) pickerOpen.value = false
}

const blueprintIdIn = response => response.data?.data?.relationships?.blueprint?.data?.id

const create = async merchantId => {
  creating.value = true
  error.value = ''
  try {
    const body = merchantId ? { from_merchant_id: merchantId } : {}
    const response = await api.call('POST', 'franchise/menu/blueprint', body, { receive: false })
    pickerOpen.value = false
    // Switching reloads the profile, which now includes the menu, so the new id is accepted.
    await store.dispatch('setActiveFranchiseMerchant', blueprintIdIn(response))
  } catch (failure) {
    error.value = failure?.response?.data?.error || 'Could not create the franchise menu. Try again.'
  } finally {
    creating.value = false
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_unref(Squares2X2Icon), {
        class: "h-5 w-5 text-brand-600",
        "aria-hidden": "true"
      })
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "mt-4 text-base font-semibold text-gray-900" }, "Set up the franchise menu", -1)),
    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " The franchise menu is where you build the products, categories, stores and prices for every location. Start with an empty menu, or copy one location's menu as a starting point. ", -1)),
    (error.value && !pickerOpen.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(NeueButton, {
        type: "secondary",
        loading: creating.value && !pickerOpen.value,
        disabled: creating.value,
        onClick: _cache[0] || (_cache[0] = $event => (create()))
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Start empty ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"]),
      _createVNode(NeueButton, {
        disabled: creating.value,
        onClick: openPicker
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("Start from a location", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(TheModal, {
      "is-open": pickerOpen.value,
      "modal-title": "Start from a location",
      onCloseModal: closePicker
    }, {
      main: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-4 text-sm text-gray-500" }, " The franchise menu starts as a copy of this location's products, categories, stores and prices. ", -1)),
        _createVNode(SelectInput, {
          modelValue: fromMerchantId.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((fromMerchantId).value = $event)),
          name: "Location",
          placeholder: "Choose a location",
          options: options.value
        }, null, 8, ["modelValue", "options"]),
        (error.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(error.value), 1))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(NeueButton, {
          type: "secondary",
          disabled: creating.value,
          onClick: closePicker
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(NeueButton, {
          disabled: !fromMerchantId.value,
          loading: creating.value,
          onClick: _cache[2] || (_cache[2] = $event => (create(fromMerchantId.value)))
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" Create franchise menu ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}
}

}